import { type UserSummaryApiModel } from '@webapp/platform/iam/data-access/api-models/UserSummaryApiModel'
import {
  RoleTypes,
  type RoleTypeEnum,
} from '@webapp/platform/iam/entities/enums/RoleTypeEnum'
import { type UserSummaryConstructor } from '@webapp/platform/iam/entities/UserSummary'

const ROLE_TYPES: readonly RoleTypeEnum[] = Object.values(RoleTypes)

// The contract types the role's `type` as a plain int; fold it onto the enum
// so an unknown value can never masquerade as a valid member downstream.
const toRoleType = (type: number): RoleTypeEnum =>
  ROLE_TYPES.find((roleType) => roleType === type) ?? RoleTypes.DEFAULT

export const mapUserSummaryApiModel = (
  user: UserSummaryApiModel
): UserSummaryConstructor => ({
  id: user.id,
  firstName: user.firstName,
  lastName: user.lastName,
  email: user.email,
  profileImage: user.profile_image ?? null,
  role: user.role
    ? { name: user.role.name, type: toRoleType(user.role.type) }
    : null,
})
